// redux/actions/municipalitiesActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_MUNICIPALITIES_REQUEST = "FETCH_MUNICIPALITIES_REQUEST";
export const FETCH_MUNICIPALITIES_SUCCESS = "FETCH_MUNICIPALITIES_SUCCESS";
export const FETCH_MUNICIPALITIES_FAILURE = "FETCH_MUNICIPALITIES_FAILURE";

export const CREATE_MUNICIPALITY_SUCCESS = "CREATE_MUNICIPALITY_SUCCESS";
export const CREATE_MUNICIPALITY_FAILURE = "CREATE_MUNICIPALITY_FAILURE";

export const UPDATE_MUNICIPALITY_REQUEST = "UPDATE_MUNICIPALITY_REQUEST";
export const UPDATE_MUNICIPALITY_SUCCESS = "UPDATE_MUNICIPALITY_SUCCESS";
export const UPDATE_MUNICIPALITY_FAILURE = "UPDATE_MUNICIPALITY_FAILURE";


// Fetch municipalities
export const fetchMunicipalities = () => async (dispatch) => {
  dispatch({ type: FETCH_MUNICIPALITIES_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/get-municipalities-admin`,
      {
        headers: { Authorization: token },
      }
    );

    dispatch({
      type: FETCH_MUNICIPALITIES_SUCCESS,
      payload: res.data?.data || [],
    });
  } catch (error) {
    const errMsg = error?.response?.data?.meta?.message || "Failed to fetch municipalities";
    dispatch({ type: FETCH_MUNICIPALITIES_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};

// Create municipality
export const createMunicipality = (data) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/create-municipality`,
      data,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({ type: CREATE_MUNICIPALITY_SUCCESS });
    toast.success(res.data?.meta?.message || "Municipality created successfully");
    dispatch(fetchMunicipalities());
  } catch (error) {
    const errMsg = error?.response?.data?.meta?.message || "Failed to create municipality";
    dispatch({ type: CREATE_MUNICIPALITY_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};




export const updateMunicipality = (municipalityData) => async (dispatch) => {
  dispatch({ type: UPDATE_MUNICIPALITY_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/update-municipality`,
      municipalityData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: UPDATE_MUNICIPALITY_SUCCESS,
      payload: response.data.data,
    });

    toast.success("Municipality updated successfully");
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message || "Failed to update municipality";

    dispatch({
      type: UPDATE_MUNICIPALITY_FAILURE,
      payload: errorMsg,
    });

    toast.error(errorMsg); // Will show backend message like "District already exists"
  }
};